import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "profile-solo",
  "use": "profile-solo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"profile-solo\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 8a3 3 0 110-6 3 3 0 010 6zm2-3a2 2 0 11-4 0 2 2 0 014 0z\" /><path d=\"M13 13v.5s0 .5.5.5.5-.5.5-.5V13s0-4-4-4H6c-4 0-4 4-4 4v.5s0 .5.5.5.5-.5.5-.5V13s0-3 3-3h4c3 0 3 3 3 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol